import { MenuTypes as Type } from '../../../types/menu';

const initialState = {
  menuList: [],
  loading: false,
  error: null,
};

const MenuListReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case Type.GET_MENU_LIST_REQUEST:
      return { ...state, loading: true, error: null, menuList: [] };
    case Type.GET_MENU_LIST_REQUEST_SUCCESS:
      return {
        ...state,
        menuList: action.payload,
        loading: false,
      };
    case Type.GET_MENU_LIST_REQUEST_FAILURE:
      return { ...state, error: action.error, loading: false };
    default:
      return state;
  }
};

export default MenuListReducer;
